"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Day = void 0;

var tslib_1 = require("tslib");

var ui_visually_hidden_1 = require("@hopin-team/ui-visually-hidden");

var date_fns_1 = require("date-fns");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("../context");

var cell_1 = require("../styled/cell");

var Day = function Day(_a) {
  var selectedDate = _a.selectedDate,
      selectedEndDate = _a.selectedEndDate,
      day = _a.day,
      onSelect = _a.onSelect,
      onSelectEndDate = _a.onSelectEndDate;
  var dateOptions = (0, react_1.useContext)(context_1.DateFieldContext).dateOptions;

  var handleClick = function handleClick() {
    if ((0, date_fns_1.isAfter)(day, selectedDate) && onSelectEndDate) {
      onSelectEndDate(day);
    } else onSelect(day);
  };

  var today = (0, react_1.useMemo)(function () {
    return new Date();
  }, []);
  var isToday = (0, date_fns_1.isSameDay)(today, day);
  var isSelected = !selectedEndDate && (0, date_fns_1.isSameDay)(selectedDate, day);
  var isSelectedStartDate = selectedEndDate && (0, date_fns_1.isSameDay)(selectedDate, day);
  var isSelectedEndDate = selectedEndDate && (0, date_fns_1.isSameDay)(selectedEndDate, day);
  var isOtherMonth = !(0, date_fns_1.isSameMonth)(day, selectedDate);
  var isInRange = selectedEndDate && (0, date_fns_1.isWithinInterval)(day, {
    start: selectedDate,
    end: selectedEndDate
  });
  return react_1.default.createElement(cell_1.Cell, {
    onClick: handleClick,
    "aria-selected": isSelected,
    isSelected: isSelected,
    isToday: isToday,
    isOtherMonth: isOtherMonth,
    isInRange: isInRange,
    isSelectedStartDate: isSelectedStartDate,
    isSelectedEndDate: isSelectedEndDate,
    isStartDateAndEndDateSame: isSelectedStartDate && isSelectedEndDate
  }, react_1.default.createElement("span", {
    "aria-hidden": true
  }, (0, date_fns_1.getDate)(day)), react_1.default.createElement(ui_visually_hidden_1.VisuallyHidden, null, (0, date_fns_1.format)(day, 'MMMM do, yyyy', dateOptions)));
};

exports.Day = Day;